import store from "../../store";
import router from '../../router';

const datatable = {
    namespaced: true,
    state: () => ({
        current_id: null,
        on_click: false,
        export_path: null,
        reload: false,
        current_filter_select: [],
        is_external_params: false,
        current_params: {},
        is_new_params: false,

    }),
    mutations: {

        setFilterSelect(state, status) {
            state.is_filter_select = status;
        },

        setExportPath(state, path) {
            state.export_path = path;
        },

        setId(state, id) {
            if (state.current_id != id) {
                state.current_params = {};
                state.current_filter_select = [];
            }

            state.current_id = id;

        },

        resetOnclick(state) {
            state.on_click = false;
        },

        setParams(state, data) {
            state.current_params = data;

        },


        resetParams(state) {
            state.current_params = {};
        },

        setReload(state, status = true) {
            state.reload = status;
        },


        setExternalParams(state, value) {
            state.is_external_params = value;
            state.is_new_params = value;
        },

        setInitialFilter(state, data) {
            state.initial_filter = data;
        },

        filterOnClick(state, data) {
            store.dispatch('api/CANCEL_PENDING_REQUESTS');

            state.reload = false;
            state.on_click = true;
            state.current_params.click = true;
            state.current_params.select = false;
            state.current_params.page = 1;
            state.current_params.search = null;
            state.current_params.filter = [];



            if (Array.isArray(data)) {
                state.current_params.filter = data;

            } else {
                state.current_params.filter.push({ name: data.name, value: data.value });
            }

            state.current_params.select = false;

            if (state.current_filter_select.length)
                state.current_params.filter = [...state.current_params.filter, ...state.current_filter_select];

            state.reload = true;

        },


        filterSelect(state, data) {
            let value = data.value ?? '';
            const key = data.name;


            state.current_params.select = true;

            let indexSelect = state.current_filter_select.findIndex((item) => item.name == key);
            if (value.length == 0) {
                state.current_params.click = false;

              

                if (indexSelect != -1) {
                    state.current_filter_select.splice(indexSelect, 1);
                }

                state.current_filter_select = [];
            } else {

                if (indexSelect == -1) {
                    state.current_filter_select = [...state.current_filter_select, ...[{ name: key, value }]];
                } else {
                    state.current_filter_select[indexSelect] = { name: key, value };
                }

            }

            state.current_params.filter = [];




            if (value.length == 0) {


                if (Array.isArray(store.state.contador.contadores[0].filter)) {
                    state.current_params.filter = store.state.contador.contadores[0].filter;
                } else {
                    state.current_params.filter.push(store.state.contador.contadores[0].filter);
                }


            } else {

                if (Array.isArray(store.state.contador.filter_current_contador)) {
                    state.current_params.filter = store.state.contador.filter_current_contador;

                } else {
                    state.current_params.filter.push(store.state.contador.filter_current_contador);
                }
            }

            state.current_params.filter = [...state.current_filter_select, ...state.current_params.filter];

            state.reload = true;


        },

        // filterByColumn(state, data) {

        //     store.dispatch('api/CANCEL_PENDING_REQUESTS');

        //     state.reload = false;

        //     state.current_params.page = 1;
        //     state.current_params.search = null;
        //     state.current_params.filter = [];


        //     if (Array.isArray(data)) {
        //         state.current_params.filter = data;

        //     } else {
        //         state.current_params.filter.push({ name: data.name, value: data.value });
        //     }

        //     state.reload = true;


        // },
        exportar() {


            window.location.assign(window.location.protocol + '//' + window.location.host + "/" + router.history.current.name + '/export');
        },
        actionButton(state, button) {

            if (!!button.mutation) {
                if (!!button.mutation.params) {
                    this.commit(`${button.mutation.path}`, button.mutation.params);
                } else {
                    this.commit(`${button.mutation.path}`);
                }
            }

            if (!!button.action) {
                if (!!button.action.params) {
                    this.dispatch(`${button.action.path}`, button.action.params)
                } else {
                    this.dispatch(`${button.action.path}`)
                }
            }


        },

    }

}


export default datatable;